export default __webpack_public_path__ + "static/media/pmr.5adcc7ac.jpg";